import { render, staticRenderFns } from "./approve-rule.vue?vue&type=template&id=a05dae98&scoped=true&"
import script from "./approve-rule.vue?vue&type=script&lang=js&"
export * from "./approve-rule.vue?vue&type=script&lang=js&"
import style0 from "./approve-rule.vue?vue&type=style&index=0&id=a05dae98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05dae98",
  null
  
)

export default component.exports